/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */

export type CSATRequestedPayloadSideEffectType =
  (typeof CSATRequestedPayloadSideEffectType)[keyof typeof CSATRequestedPayloadSideEffectType];

export const CSATRequestedPayloadSideEffectType = {
  csat_requested: "csat_requested",
} as const;
